/*
 * marking-labels/verify.js — живая камера для кодов маркировки.
 *
 * Два дела одной камерой:
 *   - ПРОВЕРКА напечатанного: ведёте камерой по ленте — тул отмечает, какие
 *     коды партии прочитались, какие нет, какие чужие и какие напечатаны
 *     БЕЗ FNC1 (символ «]d1» вместо «]d2» — касса такой код не примет);
 *   - ДОБАВЛЕНИЕ кодов, когда файла нет (коды на упаковке, старая партия).
 *
 * Кадр — общий срез живых сканеров (__qrDecode.liveFrame + liveCameraSize,
 * docs/why/primitives/qr-decode.md), камера — CameraManager (отказ называет
 * причину, сторож первого кадра — cam.show). В отличие от /barcode-scanner
 * берутся ВСЕ коды кадра, а не ближайший к центру: на ленте их видно два-три.
 *
 * window.MarkingCamera.create({ video, aim, anchor, onCodes(list), onState(s, detail) })
 *   → { start(), stop(), running() }
 *   list: [{ text, symbology }] — по разу на код, повтор того же текста в
 *   течение 2 с не сообщается.
 */
(function () {
    'use strict';
    if (window.MarkingCamera) return;

    function create(o) {
        var cam = null, loop = null, live = false, starting = false, state = {}, recent = {};
        var video = o.video;

        function emit(s, d) { try { o.onState && o.onState(s, d || {}); } catch (_) {} }

        function stop(reason) {
            if (loop) { clearInterval(loop); loop = null; }
            try { if (cam) cam.stop(); } catch (_) {}
            try { video.srcObject = null; } catch (_) {}
            if (live) emit('stopped', { reason: reason || 'user' });
            live = false;
        }

        function start() {
            if (live || starting) return Promise.resolve(false);
            starting = true;
            emit('starting');
            try { window.__qrDecode.ready().catch(function () {}); } catch (_) {}
            if (!cam) cam = new window.CameraManager({ slug: 'marking-labels' });
            var size = window.__qrDecode.liveCameraSize();
            return cam.start({ facingMode: 'environment', width: size.width, height: size.height }).then(function (stream) {
                starting = false;
                if (document.hidden) { cam.stop(); emit('stopped', { reason: 'hidden' }); return false; }
                live = true;
                emit('live');
                // play() — внутри show(), без ожидания: на потоке без кадров его
                // обещание не разрешается никогда (camera.md).
                cam.show(video, stream, { anchor: o.anchor }).then(function (ok) { if (!ok && live) stop('no_frames'); });
                state = {};
                var busy = false;
                loop = setInterval(function () {
                    if (!live || busy) return;
                    var cut = window.__qrDecode.liveFrame(video, { aim: o.aim, state: state });
                    if (!cut) return;
                    busy = true;
                    window.__qrDecode.fromCanvasFast(cut.canvas, { formats: ['DATA_MATRIX'], maxSymbols: 8 }).then(function (res) {
                        busy = false;
                        if (!live || !res || !res.length) return;
                        var now = Date.now(), out = [];
                        res.forEach(function (r) {
                            if (recent[r.text] && now - recent[r.text] < 2000) return;
                            recent[r.text] = now;
                            out.push({ text: r.text, symbology: r.symbology || null });
                        });
                        if (out.length && o.onCodes) o.onCodes(out);
                    }).catch(function (err) {
                        busy = false;
                        if (err && err.code === 'ENGINE') { stop('engine'); emit('error', { code: 'engine' }); }
                    });
                }, 250);
                return true;
            }, function (err) {
                starting = false;
                emit('error', { code: (err && err.code) || 'generic', message: cam && cam.getErrorMessage ? cam.getErrorMessage((err && err.code) || 'generic') : '' });
                return false;
            });
        }

        // pagehide приходит окну, не документу: на document камера не гасла при уходе.
        window.addEventListener('pagehide', function () { if (live) stop('pagehide'); });
        document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden' && live) stop('hidden'); });

        return {
            start: start, stop: stop, running: function () { return live; },
            // Дверь камеры уже объяснила отказ у нажатой кнопки — тул не повторяет его тостом.
            hasHelp: function () { return !!(cam && cam.hasHelp && cam.hasHelp()); },
        };
    }

    window.MarkingCamera = { create: create };
})();
